// @flow

import PageContainer from 'insight/pages/common/PageContainer';
import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import Box from '@mui/material/Box';
import { useIntl } from 'react-intl';
import AppThingsboard from 'insight/components/serviceOverview/AppThingsboard';
import AppUI from 'insight/components/serviceOverview/AppUI';
import AppPaymentServer from 'insight/components/serviceOverview/AppPaymentServer';
import PageTitle from '../../../common/components/PageTitle';

const ServiceStatusApp = (): React$Node => {
  const intl = useIntl();
  const [tabIndex, setTabindex] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabindex(newValue);
  };

  return (
    <PageContainer>
      <PageTitle titleKey={'app.page.service.farmerApp.status'} />
      <Box component="main" sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label={intl.formatMessage({ id: 'app.service.overview.thingsboard' })} />
          <Tab label={intl.formatMessage({ id: 'app.service.overview.ui' })} />
          <Tab label={intl.formatMessage({ id: 'app.service.overview.paymentServer' })} />
        </Tabs>
        {tabIndex === 0 && <AppThingsboard />}
        {tabIndex === 1 && <AppUI />}
        {tabIndex === 2 && <AppPaymentServer />}
      </Box>
    </PageContainer>
  );
};

export default ServiceStatusApp;
